import Auth from '../modules/Authentication'
import { apiUrl } from '../variables/index'
import { handleErrors, handleResponse } from '../modules/Utils'
import { streamUrl } from '../variables/index'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
export default class Employees {
  constructor() {
    this.auth = new Auth()
  }

  create = (member) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}employees/`, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(member),
    }).then(handleErrors)
  }
  getImage = (key) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}employees/${key}/image`, { headers }).then(handleErrors)
  }
  list = (status) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}employees/` + (status ? `?status=${status || ''}` : ''), { headers })
      .then(handleErrors)
      .then(handleResponse)
  }
  checkImage = (fileID) => {
    return fetch(`${streamUrl}files/${fileID}?action=view&access_token=${this.auth.getAccessToken()}`).then(
      handleErrors
    )
  }
  get = (key) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}employees/${key}`, { headers }).then(handleErrors)
  }
  getMember = (key) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}employees/${key}/member`, { headers }).then(handleErrors)
  }
  update = (data) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}employees/`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    }).then(handleErrors)
  }
  permissions = {
    list: (key, org) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}employees/${key}/permissions/${org}`, {
        headers,
      }).then(handleErrors)
    },
    update: (key, org, data) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}employees/${key}/permissions/${org}`, {
        headers: headers,
        method: 'PATCH',
        body: JSON.stringify(data),
      }).then(handleErrors)
    },
  }
  banks = {
    list: (key) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}employees/${key}/banks/`, { headers }).then(handleErrors).then(handleResponse)
    },
    update: (key, bankID, data) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}employees/${key}/banks/${bankID}`, {
        headers: headers,
        method: 'PATCH',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
  }
  contracts = {
    list: (key) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}employees/${key}/contracts/`, { headers }).then(handleErrors).then(handleResponse)
    },
  }
  payQuery = {
    list: (key) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}employees/${key}/payQuery/`, { headers }).then(handleErrors).then(handleResponse)
    },
  }
  requisitions = {
    list: () => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}labourreqs/`, { headers }).then(handleErrors).then(handleResponse)
    },
  }
  files = {
    list: (key) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}employees/${key}/files/`, { headers }).then(handleErrors).then(handleResponse)
    },
    update: (key, bankID, data) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}employees/${key}/banks/${bankID}`, {
        headers: headers,
        method: 'PATCH',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
  }
  entitlements = {
    get: (key) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}employees/${key}/entitlements/`, { headers }).then(handleErrors).then(handleResponse)
    },
  }
}
